export function prepareDownloadUrl(path) {
	let fileDownload = window.location.protocol + '//' + window.location.host + path;
	// The port needs to be replaced when running in dev mode
	if ('development' == process.env.NODE_ENV) {
		//console.debug(fileDownload);
		fileDownload = fileDownload.replace("3000", "8080");
		//console.debug(fileDownload);
	}
	return fileDownload;
}
